import gql from 'graphql-tag';
//Used in information block on top
export default gql`
mutation ($args: FA_EditOrderInputs!){
    fakturaAssist{
    	callFA_EditOrder(args: $args){
	    	errorCode
			errorText
			orderId
			orderNo
	 	}
 	}
}`;
